<template>
  <div class="animated fadeIn" id="list-sirens">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened"><i class="icon-arrow-down"></i></span>
              <span class="when-closed"><i class="icon-arrow-up"></i></span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="searchByFilters">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="siren"><strong>SIREN</strong></label>
                    <b-form-input type="text" id="siren" v-model="siren"
                                  :class="{hasError: errors.siren !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.siren }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="raison_sociale"><strong>Raison sociale</strong></label>
                    <b-form-input type="text" id="raison_sociale" v-model="raison_sociale"
                                  :class="{hasError: errors.raison_sociale !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.raison_sociale }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="num_contrat"><strong>N° Contrat</strong></label>
                    <b-form-input type="text" id="num_contrat" v-model="num_contrat"
                                  :class="{hasError: errors.num_contrat !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.num_contrat }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="dpt"><strong>Département</strong></label>
                    <b-form-input type="text" id="dpt" v-model="departement"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="delegation"><strong>Délégation</strong></label>
                      <span>
                        <b-form-select id="delegationCommerciale"
                                       :plain="true"
                                       :options="allDelegations"
                                       v-model="delegationCommercialeId">
                        </b-form-select>
                      </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="searchByFilters" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
                <span class="field-error">{{ errors.critere }}</span>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des SIREN</strong>
      </b-card-header>
      <b-card-body>
        <sirens-table :tableEntry="tableParam" ref="siren_table"></sirens-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '../../../utils/auth'
  import SirensTable from './SirensTable'

  export default {
    name: "Sirens",
    components: {SirensTable},
    data() {
      return {
        siren: '',
        num_contrat: '',
        raison_sociale: '',
        noSearch: 'noSearch',
        departement: '',
        delegationCommercialeId: '',
        allDelegations: [],
        errors: {siren: '', num_contrat: '', raison_sociale: '', critere: ''}
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
      this.getDelegations();

      if (this.$route.query.si) {
        this.siren = this.$route.query.si
      }
      if (this.$route.query.nc) {
        this.num_contrat = this.$route.query.nc
      }
      if (this.$route.query.rs) {
        this.raison_sociale = this.$route.query.rs
      }
      if (this.$route.query.dpt) {
        this.departement = this.$route.query.dpt
      }
      if (this.$route.query.dci) {
        this.delegationCommercialeId = this.$route.query.dci
      }
      // Si une des query de la route est rempli c'est qu'on revient d'une fiche et donc il y a eu une recherche , donc noSearch = ''
      if (this.$route.query.rs || this.$route.query.nc || this.$route.query.si || this.$route.query.dpt || this.$route.query.delegationCommercialeId || this.$route.query.co) {
        this.noSearch = ''
      }
      this.getDelegations();
    },
    computed: {
      tableParam: {
        get() {
          return {
            siren: this.siren,
            num_contrat: this.num_contrat,
            raison_sociale: this.raison_sociale,
            noSearch: this.noSearch,
            departement: this.departement,
            delegationCommercialeId: this.delegationCommercialeId,
          };
        }
      },
    },
    methods: {
      searchByFilters() {
        if (this.validateData()) {
          this.noSearch = ''
          this.$refs.siren_table.$refs.table.refresh()
        }
      },
      validateData() {
        this.clearErrors()
        let valid = true

        /*if (this.siren === '' && this.num_contrat === '' && this.raison_sociale === '' && ) {
          this.errors.critere = 'Vous devez définir au moins un critère de recherche.'
          valid = false
        }*/

        return valid;
      },
      getDelegations() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllDelegations")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let delegations = response.data.data;
            for (let key in delegations) {
              this.allDelegations.push({
                text: delegations[key].nom,
                value: delegations[key].id
              });
            }
            this.allDelegations.unshift({text: 'N.D', value: null});
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      clearErrors() {
        this.errors.siren = ''
        this.errors.num_contrat = ''
        this.errors.raison_sociale = ''
        this.errors.critere = ''
      },
      clearForm() {
        this.siren = ''
        this.num_contrat = ''
        this.raison_sociale = ''
        this.errors.critere = ''
      }
    }
  };
</script>
